import type { ProductListItem } from '@/schemas/v2/ec'
import { Skeleton } from '@mantine/core'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TicketCard } from './TicketCard'

type Props = {
  products: ProductListItem[]
  loading?: boolean
  /** チェックアウト起動中の商品ID（多重クリック防止） */
  submittingProductId?: number | null
  onSelect: (product: ProductListItem) => void
}

function TicketCardSkeleton() {
  return (
    <div className="flex flex-col gap-2 rounded-lg border border-gray-200 bg-white p-4">
      <Skeleton height={160} radius="md" />
      <Skeleton height={24} width="70%" radius="sm" />
      <Skeleton height={16} width="90%" radius="sm" />
      <div className="mt-1 flex items-center justify-between">
        <Skeleton height={28} width="30%" radius="sm" />
        <Skeleton height={36} width={72} radius="xl" />
      </div>
    </div>
  )
}

/** チケット（商品）一覧。 */
export const TicketSelectList: FC<Props> = ({ products, loading = false, submittingProductId = null, onSelect }) => {
  const { t } = useTranslation()

  if (loading) {
    return (
      <div className="flex flex-col gap-6 px-4">
        {Array.from({ length: 3 }).map((_, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: 静的なスケルトン行のため index を key に使用
          <TicketCardSkeleton key={`ticket-skeleton-${i}`} />
        ))}
      </div>
    )
  }

  if (products.length === 0) {
    return (
      <p className="py-10 text-center text-sm text-gray-500">
        {t('ec.ticket_select.empty', '販売中のチケットはありません')}
      </p>
    )
  }

  return (
    <div className="flex flex-col gap-6 px-4">
      {products.map((product) => (
        <TicketCard
          key={product.id}
          product={product}
          onSelect={onSelect}
          submitting={submittingProductId === product.id}
        />
      ))}
    </div>
  )
}
